export const translationBaseDir = 'pages.History.Table.titles';
